module.exports = __webpack_public_path__ + "img/wolt.e12e53c8.png";